import levels from "./levels";

import { gameResoursesLoaded } from "./store";

const baseUrl = "";

const sounds = {
  countdownTick: {
    src: baseUrl + "sounds/countdownTick.mp3",
  },

  tap: {
    src: baseUrl + "sounds/buttonTap.mp3",
  },

  bgClassic: {
    src: baseUrl + "sounds/bg_classic.mp3",
  },
  bgJazz: {
    src: baseUrl + "sounds/bg_jazz.mp3",
  },
  bgRock: {
    src: baseUrl + "sounds/bg_rock.mp3",
  },
  bgPop: {
    src: baseUrl + "sounds/bg_pop.mp3",
  },
  bgRap: {
    src: baseUrl + "sounds/bg_rap.mp3",
  },
  bgMetal: {
    src: baseUrl + "sounds/bg_metal.mp3",
  },

  victory: {
    src: baseUrl + "sounds/victory.mp3",
  },

  defeat: {
    src: baseUrl + "sounds/defeat.mp3",
  },
};

let totalSounds = Object.keys(sounds).length;
let loaded = 0;

function handler() {
  loaded += 1;

  if (loaded == totalSounds) {
    gameResoursesLoaded();
  }
}

for (let [name, sound] of Object.entries(sounds)) {
  const player = new Audio();
  player.preload = "auto";

  player.addEventListener("canplaythrough", handler, false);

  player.addEventListener(
    "error",
    () => {
      alert("Что-то пошло не так! Попробуйте перезагрузить страницу");
    },
    false
  );

  sound.player = player;

  sound.player.preload = "auto";
  sound.player.src = sound.src;
  sound.player.load();
}

export default sounds;
